<template>
  <div class="forgotPassword">
    <div class="container">
      <h1>認証コードと新しいパスワードを入力</h1>
      <el-row class="container__form">
        <el-input placeholder="123456" v-model="code"></el-input>
      </el-row>
      <el-row class="container__form">
        <el-input
          placeholder="******"
          v-model="password"
          type="password"
        ></el-input>
      </el-row>
      <el-row class="container__buttons">
        <div class="button button--right">
          <el-button @click="onClickBack">戻る</el-button>
          <el-button @click="onClickResetPassword" type="primary"
            >送信</el-button
          >
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import Auth from "@/services/auth.service";
const authService = new Auth();

export default {
  components: {},
  mounted () {},
  data () {
    return {
      code: "",
      password: "",
    };
  },
  computed: {
    email () {
      return this.$store.state.auth.email;
    },
  },
  methods: {
    onClickBack () {
      const { $router } = this;
      $router.push("/sign-in");
    },
    async onClickResetPassword () {
      const { $router, email, code, password } = this;
      await resetPassword(email, code, password);
      alert("パスワードをリセットしました");
      $router.push("/sign-in");
    },
  },
};

/**
 * send password reset email
 * @async
 * @param {string} email - The email address
 * @returns {Promise<Object>} Promise object represents the result of authentication
 */
async function resetPassword (email, code, password) {
  try {
    return await authService.forgotPasswordSubmit(email, code, password);
  } catch (err) {
    return false;
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  position: absolute;
  width: 40vw;
  height: 40vw;
  margin: auto;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.logo {
  width: 80%;
  margin: 50px auto;
}
.container__form {
  margin-bottom: 10px;
}
.container__buttons {
  display: flex;
}

.button {
  display: flex;
  flex: 1;
  align-items: flex-end;
}

.button--right {
  justify-content: flex-end;
}
</style>
